import { HTMLAttributes } from 'react'

import { sectionsMap } from '@/components/sections'

import { WPPageData } from '@/types'

export type BuilderProps = HTMLAttributes<HTMLElement> & {
  pageData?: WPPageData
}

const Builder = ({ pageData }: BuilderProps) => {
  return (
    <>
      {pageData?.acf?.builder?.map(({ acf_fc_layout, ...section }, index) => {
        const Section = sectionsMap[acf_fc_layout]
        return (
          <Section key={`section-${index}`} className="relative" {...section} />
        )
      })}
    </>
  )
}

export default Builder
